// extracted by mini-css-extract-plugin
module.exports = {"header":"_6KsX9N","header__left":"eNkBsx","header__right":"D-oKCr","icon":"vYLJ0B","wifi":"_5N4J1p","noSignal":"hQ1rDn"};